import { AwsRum, type AwsRumConfig } from 'aws-rum-web'
import type { RumClient } from '~/types/rum'

const noopRum: RumClient = {
  recordError: () => {},
  recordEvent: () => {}
}

export default defineNuxtPlugin(() => {
  const { rum } = useRuntimeConfig().public as {
    rum?: {
      enabled: boolean
      appMonitorId: string
      identityPoolId: string
      region: string
      sessionSampleRate: number
    }
  }

  if (!rum?.enabled || !rum.appMonitorId) {
    return { provide: { rum: noopRum } }
  }

  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return { provide: { rum: noopRum } }
  }

  try {
    const config: AwsRumConfig = {
      sessionSampleRate: rum.sessionSampleRate,
      identityPoolId: rum.identityPoolId,
      endpoint: `https://dataplane.rum.${rum.region}.amazonaws.com`,
      telemetries: ['errors', 'performance', 'http'],
      allowCookies: true,
      enableXRay: true
    }
    const client = new AwsRum(rum.appMonitorId, '1.0.0', rum.region, config) as unknown as RumClient
    return { provide: { rum: client } }
  } catch (e) {
    console.warn('[rum] init failed; continuing without telemetry', e)
    return { provide: { rum: noopRum } }
  }
})
